import Vue from "vue";
import * as fundebug from "fundebug-javascript";
import FundebugVue from "fundebug-vue";
fundebug.apikey =
  "cadabeb57d60458656737cabae85cbf2012b5cde54ceb3e3c877469b909bd465";
new FundebugVue(fundebug).installVueErrorHandler(Vue); // Vue 2.x
// createApp(App).use(new FundebugVue(fundebug)).x.x.mount("#app"); // Vue 3.x
require("fundebug-revideo");
